import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BatchRequirementService } from '@services/bathupdaterequirement.service';
import { LoadingService } from '@services/loading.service';
import { UsersService } from '@services/users.service';
import { ResponseObjectAPI } from 'src/app/models/responseObjectAPI';

@Component({
    selector: 'change-requester-dialog',
    templateUrl: './change-requester-dialog.component.html',
    styleUrls: ['./change-requester-dialog.component.scss'],
    standalone: false
})

export class ChangeRequesterDialogComponent implements OnInit {
  form = new FormGroup({
    commentArea: new FormControl('')
  });

  @Input() requirementIds;
  @Output() changed = new EventEmitter();
  userId: number | null = null;
  users: any[] = [];
  isValidate: boolean = false;
  isSubmitting = false;

  constructor(
    public activeModal: NgbActiveModal,
    private batchRequirementService: BatchRequirementService,
    private _loading: LoadingService,
    private usersService: UsersService
  ) { }

  async ngOnInit() {
    this.usersService.getUsers().subscribe((response: any) => {
      this.users = response.result;
    });
  }

  onValueUserChange(value: string) {
    this.userId = value ? parseInt(value) : null;
    this.isValidate = !!this.userId;
  }

  async saveDataToChangeRequester() {
    if (this.isSubmitting) return;

    try {
      this.isSubmitting = true;
      if (!this.userId) {
        return;
      }
      this._loading.reloadStart(null, this._loading.blockUIList);
      const body = {
        requirementids: this.requirementIds,
        userid: this.userId
      };
      this.batchRequirementService.setCreator(body).subscribe(
        (resp: ResponseObjectAPI) => {
          this.changed.emit(true);
        },
        (error) => {
          this._loading.reloadStop(null);
          alert(error.error?.message || 'Error al cambiar el solicitante');
        }
      );
    } finally {
      this.isSubmitting = false;
    }
  }
}
